import {
  HTTP_ERROR_MESSAGE_KEYS,
  STATUS_TO_KEY,
  type HttpErrorMessageKey,
  type MappedHttpStatusCode,
} from "@core/consts/http-error-message-keys.const";

import {
  ENDPOINT_ERROR_RULES,
  type EndpointErrorMessageKey,
  type EndpointErrorRule,
} from "@core/consts/endpoint-error-message-keys.const";

const isMappedHttpStatusCode: (status: number) => status is MappedHttpStatusCode =
  (status: number): status is MappedHttpStatusCode => {
  return Object.prototype.hasOwnProperty.call(STATUS_TO_KEY, status);
};

const urlMatches: (url: string, pattern: string | RegExp) => boolean =
  (url: string, pattern: string | RegExp): boolean => {
  const regex: RegExp = typeof pattern === "string" ? new RegExp(pattern) : pattern;

  return regex.test(url);
};

const getEndpointKey: (status: number, url: string) => EndpointErrorMessageKey | null =
  (status: number, url: string): EndpointErrorMessageKey | null => {
  const matchingRule: EndpointErrorRule | undefined = ENDPOINT_ERROR_RULES.find(
    (rule: EndpointErrorRule) => rule.status === status && urlMatches(url, rule.pattern),
  );

  return matchingRule?.key ?? null;
};


const getGenericKey: (status: number | null) => HttpErrorMessageKey =
  (status: number | null): HttpErrorMessageKey => {
  if (status === null) return HTTP_ERROR_MESSAGE_KEYS.unexpected;

  if (status === 0) return HTTP_ERROR_MESSAGE_KEYS.noConnection;
  
  if (status >= 500) return HTTP_ERROR_MESSAGE_KEYS.serverError;

  if (isMappedHttpStatusCode(status)) return STATUS_TO_KEY[status];

  return HTTP_ERROR_MESSAGE_KEYS.unexpected;
};


export const getHttpErrorMessageKey: (status: number | null, requestUrl?: string) => string =
  (status: number | null, requestUrl?: string): string => {
  
  if (requestUrl != null && requestUrl !== "" && status != null) {
    const endpointKey: EndpointErrorMessageKey | null = getEndpointKey(status, requestUrl);

    if (endpointKey) return endpointKey;

  }

  return getGenericKey(status);
};
